import { useEffect, useState } from "react"
import Popup from "../../../components/Popup"

export default function ReturnTea({ onClose, edit = false, onSubmit, updateData = {}, submitting }) {
    const formName = 'returnRawTea';
    // Assume updateData.teabags is the list of teabags to return against
    // Each teabag: { id, type (string), totalBags, remainingBags }
    const [teabags, setTeabags] = useState([]);
    const [data, setData] = useState({})

    // Each item: { ...teabagProps, returnBags: 0 }
    useEffect(() => {
        if (updateData?.teabags && Array.isArray(updateData.teabags)) {
            setTeabags(updateData.teabags.map(tb => ({
                ...tb,
                returnBags: 0,
            })));
        }
    }, [updateData]);

    // type: 'returnBags', index, value (number)
    const setItem = (type, index, value) => {
        setTeabags(prev => {
            const updated = [...prev];
            if (type === 'returnBags') {
                let val = Number(value);
                if (isNaN(val)) val = 0;
                if (val > updated[index].remainingBags) val = updated[index].remainingBags;
                if (val < 0) val = 0;
                updated[index].returnBags = val;
            }
            return updated;
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Filter teabags to include only those with returnBags > 0 and only submit {id, returnBags}
        const filteredTeabags = teabags
            .filter(tb => Number(tb.returnBags) > 0)
            .map(tb => ({
                id: tb.id,
                returnBags: tb.returnBags
            }));
        onSubmit(e, { ...data, teaBags: filteredTeabags });
    };

    return (
        <Popup
            size="sm"
            submitting={submitting}
            title={'Return Tea Bags'}
            submitTitle={'Return'}
            onClose={onClose}
            formName={formName}
        >
            <form onSubmit={handleSubmit} id={formName} className='w-full'>
                <div className="block grid-cols-2 gap-x-3 gap-y-0 w-full">
                    <div className="col-span-4 mt-4">
                        <label>Return Raw Tea Bags</label>
                        {
                            teabags.map((item, index) => (
                                <TeaBag
                                    key={item.id || index}
                                    item={item}
                                    index={index}
                                    setItem={setItem}
                                />
                            ))
                        }
                    </div>
                </div>

                <div>
                    <label>Reason for Return</label>
                    <textarea
                        className="w-full py-2 px-4 text-[13px] font-medium border border-gray-200 bg-gray-100 resize-none h-24"
                        value={data.reason}
                        onChange={(e) => setData({ ...data, reason: e.target.value })}
                        placeholder="Reason for Return"
                    />
                </div>
            </form>
        </Popup>
    );
}


const TeaBag = ({ item, setItem, index }) => {
    // item: { type, totalBags, remainingBags, returnBags }
    return (
        <div className="flex items-center relative mb-4">
            <div className="grid grid-cols-7 w-full mr-10 border border-gray-200 bg-[#fcfcfc] rounded-[4px] overflow-hidden">
                {/* Weight of the teabag */}
                <div className="col-span-2">
                    <input
                        type="text"
                        className="w-full py-2 px-4 text-[13px] font-medium border-r border-r-gray-200 bg-gray-100"
                        value={`${item.type} Kg`}
                        readOnly
                        disabled
                        placeholder="Weight Of Bag"
                    />
                </div>
                {/* Total bags (all time) */}
                {/* <div className="col-span-2">
                    <input
                        type="number"
                        className="w-full py-2 px-4 text-[13px] font-medium border-r border-r-gray-200 bg-gray-100"
                        value={`${item.numberOfBags} Bags`}
                        readOnly
                        disabled
                        placeholder="Total Bags"
                    />
                </div> */}
                {/* Remaining bags (editable only by system, show only) */}
                <div className="col-span-2">
                    <input
                        type="number"
                        className="w-full py-2 px-4 text-[13px] font-medium border-r border-r-gray-200 bg-gray-100"
                        value={item.remainingBags}
                        readOnly
                        disabled
                        placeholder="Remaining Bags"
                    />
                </div>
                {/* Number of bags to return (input, max: remainingBags) */}
                <div className="col-span-2">
                    <input
                        type="number"
                        min={0}
                        max={item.remainingBags}
                        step={1}
                        required
                        className="w-full py-2 px-4 text-[13px] font-medium"
                        value={item.returnBags}
                        onChange={(e) => setItem('returnBags', index, e.target.value)}
                        placeholder="Bags to Return"
                    />
                </div>
            </div>
        </div>
    );
};